import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar'

const BccSnackbar = withStyles({})((props: any) => <Snackbar {...props} />)

export default BccSnackbar
